import { formatCnpjCpfHelper } from "@/modules/customer/helpers/format-fields-customer-form.helper";
import { Card, CardContent, CardHeader, CardTitle } from "@/modules/shared/components/ui/card";
import { cn } from "@/modules/shared/lib/utils";
import type { Entity } from "@/modules/shared/types/entity.type";
import { Search } from "lucide-react";

type EntityCardComponentProps = {
	entity: Entity
	disabled?: boolean
	onOpen: () => void
	title: string
	descrpition?: string
}

export function EntityCardComponent({ entity, disabled, onOpen, title, descrpition }: EntityCardComponentProps) {

	return (
		<Card
			key={entity?.idEntidade}
			onClick={
				disabled
					? null
					: onOpen
			}
			className={cn("min-h-[80px] w-full md:min-w-[50%] cursor-pointer", disabled && 'cursor-not-allowed')}
		>
			<CardHeader className="p-4">
				<CardTitle className={cn("text-md flex justify-between font-medium", disabled && 'text-gray-400 cursor-not-allowed')}>
					{title}
					<p>
						{entity?.idEntidade ? (
							<Search size={20} className="text-gray-500" />
						) : null}
					</p>
				</CardTitle>
			</CardHeader>
			<CardContent className="p-4 text-sm -mt-5">
				{entity?.idEntidade ? (
					<>
						<p className="font-medium ">
							{entity?.idEntidade} -{' '}
							{entity?.razaoSocialNome}
						</p>
						<p>
							{formatCnpjCpfHelper(
								entity?.cnpjCpf,
							)}
						</p>
						<p className="text-sm">
							{entity?.logradouro},{' '}
							{entity?.numero}
						</p>
						<p className="text-sm">
							{entity?.cidade},{' '}
							{entity?.uf}
						</p>
					</>
				) : (
					<div className="flex flex-1 justify-center flex-col items-center text-sm gap-2 text-center">
						<Search size={20} className={cn("text-gray-500", disabled && "text-gray-300")} />
						<p className={cn("text-gray-700", disabled && "text-gray-300")}>
							{
								descrpition || 'Clique para selecionar uma entidade'
							}
						</p>
					</div>
				)}
			</CardContent>
		</Card>
	)
}